import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { L10n } from '~commonInfra/L10n/L10n';
import { CommonErrorCode } from '~commonInfra/utils/ErrorCodes';

import { siteUrlsSelector } from '../../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { ICustomViewInfo } from '../../ServerApi/requests/CustomViews/ICustomViewInfo';

function customViewUrl(info: ICustomViewInfo): string {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return siteUrls.redirectToCustomViewUrl(info.viewId, info.owner.username, info.urlId);
}

function errorMessageFor(errorCode: number) {
  switch (errorCode) {
    case CommonErrorCode.CustomViewNotFound:
      return Messages.errorCustomViewNotFound({ ACTIONED: L10n.elideIfLong('deleted') });
    case CommonErrorCode.SiteUserNotFound:
      return Messages.errorUserNotFoundOnSite();
    default:
      return Messages.errorUnknown();
  }
}

function errorDetailsFor(errorItem: IErrorItem<ICustomViewInfo>): IErrorDetail {
  return {
    itemName: errorItem.item.name,
    itemUrl: customViewUrl(errorItem.item),
    errorMessage: errorMessageFor(errorItem.error.code)
  };
}

export const CustomViewErrors = {
  errorDetailsFor,
  errorMessageFor
};
